import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, Typography, Grid } from '@material-ui/core';
import api from 'services/api';
import { getCodEmpresa } from 'lib/functions';
const GRUPOS = [
  { titulo: 'Receptivo', itens: [['VENDEOPCIONAIS', 'Opcionais'], ['VENDETRANSPORTE', 'Transporte']] },
  { titulo: 'Agência de viagens', itens: [['VENDEAEREO', 'Aéreo'], ['VENDEHOSPEDAGEM', 'Hospedagem'], ['VENDESEGUROVIAGEM', 'Seguro Viagem'], ['VENDELOCADORAVEICULOS', 'Locadora de Veículos'], ['VENDESERVICOSVIAGENS', 'Serviços'], ['VENDECRUZEIROS', 'Cruzeiros'], ['VENDEPACOTESVIAGENS', 'Pacotes'], ['VENDEOUTROSVIAGENS', 'Outros']] }
];
const CAMPOS = GRUPOS.reduce((todos, grupo) => todos.concat(grupo.itens.map(([campo]) => campo)), []);
const normalizar = dados => Object.fromEntries(CAMPOS.map(campo => [campo, String(dados?.[campo] ?? dados?.[campo.toLowerCase()] ?? 'N').trim().toUpperCase() === 'S' ? 'S' : 'N']));
export default function ConfiguracaoGeralFront() {
  const [valores, setValores] = useState({});
  const [originais, setOriginais] = useState({});
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');
  const codempresa = getCodEmpresa() || 0;
  useEffect(() => {
    let ativo = true;
    api.get('/front/configuracoes/geral', { params: { codempresa } }).then(({ data }) => {
      if (ativo) { setValores(normalizar(data)); setOriginais(normalizar(data)); }
    }).catch(e => { if (ativo) setErro(e.response?.data?.error || 'Não foi possível carregar as configurações.'); })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [codempresa]);
  const salvar = async () => {
    setSalvando(true); setErro(''); setMensagem('');
    try { const dados = normalizar(valores); await api.put('/front/configuracoes/geral', { codempresa, ...dados }); setValores(dados); setOriginais({ ...dados }); setMensagem('Configurações salvas com sucesso.'); }
    catch (e) { setErro(e.response?.data?.error || 'Erro ao salvar configurações.'); }
    finally { setSalvando(false); }
  };
  return <div style={{ padding: 24, maxWidth: 1050 }}>
    <Typography variant="h5">Configurações — Front</Typography>
    <Card style={{ marginTop: 16 }}><CardContent>
      <Typography variant="h6">Geral</Typography>
      <Typography color="textSecondary" style={{ marginTop: 8, marginBottom: 16 }}>Realiza venda de</Typography>
      {carregando ? <CircularProgress size={24} /> : GRUPOS.map(grupo => <div key={grupo.titulo} style={{ marginBottom: 18 }}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{grupo.titulo}</Typography>
        <Grid container spacing={1}>{grupo.itens.map(([campo, rotulo]) => <Grid item xs={12} sm={6} md={4} key={campo}>
          <FormControlLabel control={<Checkbox color="primary" checked={valores[campo] === 'S'} disabled={salvando || !!erro && !Object.keys(valores).length}
            onChange={e => { setValores(v => ({ ...v, [campo]: e.target.checked ? 'S' : 'N' })); setMensagem(''); }} />} label={rotulo} />
        </Grid>)}</Grid>
      </div>)}
      {erro && <Typography color="error">{erro}</Typography>}
      {mensagem && <Typography color="primary">{mensagem}</Typography>}
      <div style={{ marginTop: 20, display: 'flex', gap: 12 }}>
        <Button variant="contained" color="primary" onClick={salvar} disabled={carregando || salvando || !Object.keys(valores).length}>{salvando ? 'Salvando...' : 'Salvar'}</Button>
        <Button variant="outlined" onClick={() => { setValores({ ...originais }); setErro(''); setMensagem(''); }} disabled={carregando || salvando}>Cancelar</Button>
      </div>
    </CardContent></Card>
  </div>;
}
